export default [
  {
    id: 1,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini",
    role: "Social Media Strategist",
    projects: ["SG", "PQ", "CB", "CB"],
    time: "113:27:25",
    activity: 50,
    idle: 11,
    notes: 5,
    details: [
      {
        date: "Tue, Apr 1, 2025",
        code: "SG",
        name: "Sky Grid",
        desk: "Worked Desk 1",
        time: "9:32:37",
        activity: 50,
        idle: 9,
        notes: "2 Notes"
      },
      {
        date: "Wed, Apr 2, 2025",
        code: "PQ",
        name: "Project Quantum",
        desk: "Worked Desk 1",
        time: "8:44:49",
        activity: 50,
        idle: 9,
        notes: "-"
      },
      {
        date: "Thu, Apr 3, 2025",
        code: "CB",
        name: "Creative Boost",
        desk: "Worked Desk 2",
        time: "9:28:58",
        activity: 60,
        idle: 8,
        notes: "3 Notes"
      }
    ]
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini",
    role: "Social Media Strategist",
    projects: ["SG", "PQ", "CB"],
    time: "113:27:25",
    activity: 44,
    idle: 10,
    notes: 4,
    details: [
      {
        date: "Tue, Apr 1, 2025",
        code: "SG",
        name: "Sky Grid",
        desk: "Worked Desk 1",
        time: "9:32:37",
        activity: 50,
        idle: 9,
        notes: "2 Notes"
      },
      {
        date: "Wed, Apr 2, 2025",
        code: "PQ",
        name: "Project Quantum",
        desk: "Worked Desk 1",
        time: "8:44:49",
        activity: 50,
        idle: 9,
        notes: "-"
      },
      {
        date: "Thu, Apr 3, 2025",
        code: "CB",
        name: "Creative Boost",
        desk: "Worked Desk 2",
        time: "9:28:58",
        activity: 60,
        idle: 8,
        notes: "3 Notes"
      }
    ]
  }
];